module.exports = __webpack_public_path__ + "img/login_back.04e1af82.png";